var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.emailVerified)?_c('div',{staticClass:"overlay"},[_c('div',{staticClass:"warning"},[_c('p',[_vm._v(_vm._s(_vm.$t('dashboard.verification.message.a')))]),_c('p',[_vm._v(_vm._s(_vm.$t('dashboard.verification.message.b')))]),_c('VVerificationRequiredActions')],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }